(() => {
  const storageKey = 'cc-line-banner-hidden-until';
  const legacyStorageKey = 'cc-line-banner-closed-at';

  document.querySelectorAll('[data-cc-line-banner]').forEach(banner => {
    if (banner.dataset.initialized) return;
    banner.dataset.initialized = 'true';

    const isPreviewMode =
      banner.dataset.designMode === 'true' ||
      new URLSearchParams(window.location.search).has('preview_theme_id') ||
      (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main');

    let hiddenUntil = 0;
    try {
      localStorage.removeItem(legacyStorageKey);
      if (isPreviewMode) {
        localStorage.removeItem(storageKey);
      } else {
        hiddenUntil = Number(localStorage.getItem(storageKey)) || 0;
        if (hiddenUntil && Date.now() >= hiddenUntil) {
          localStorage.removeItem(storageKey);
          hiddenUntil = 0;
        }
      }
    } catch (_) {
      // 保存を許可しない環境でも、このページ内の開閉は利用できる。
    }
    if (!isPreviewMode && hiddenUntil > Date.now()) return;

    const show = () => {
      banner.classList.add('is-visible');
      window.removeEventListener('scroll', show);
    };
    if (window.scrollY > 0) {
      show();
    } else {
      window.addEventListener('scroll', show, { passive: true });
    }

    banner.querySelector('[data-cc-line-banner-close]').addEventListener('click', () => {
      banner.classList.remove('is-visible');
      window.removeEventListener('scroll', show);
      if (!isPreviewMode) {
        try {
          const now = new Date();
          const expiry = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime();
          localStorage.setItem(storageKey, String(expiry));
        } catch (_) {
          // 保存できない場合は、このページ内だけ非表示にする。
        }
      }
    });
  });
})();
